import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/plus.svg
 */
const IconPlus: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M24 12.426a1.427 1.427 0 01-1.432 1.427H13.86v8.714A1.436 1.436 0 0112.428 24h-.856a1.432 1.432 0 01-1.431-1.433v-8.714H1.43c-.188 0-.374-.034-.547-.106A1.428 1.428 0 010 12.427v-.856a1.428 1.428 0 011.43-1.43h8.71V1.426A1.427 1.427 0 0111.573 0h.856a1.432 1.432 0 011.431 1.426v8.715h8.71c.187 0 .374.035.547.107a1.434 1.434 0 01.775.776c.072.174.109.36.109.547v.855z"
      fill="currentColor"
    />
  </svg>
);

export default IconPlus;
